module.exports = __webpack_public_path__ + "img/carrousel-rad-digi-sala-2.a66d6af0.png";